package org.koin.ksp.generated

import org.koin.core.module.Module
import org.koin.dsl.*


public val com_essntl_features_currency_data_di_CurrencyModule : Module get() = module {
	single() { _ -> com.essntl.features.currency.data.repository.CurrencyRepositoryImpl(supabase=get()) } bind(com.essntl.features.currency.domain.repository.CurrencyRepository::class)
	single() { _ -> com.essntl.features.currency.data.supabase.CurrencySupabaseDataSource(supabaseClient=get()) } bind(com.essntl.features.currency.data.supabase.CurrencySupabaseDataSource::class)
}
public val com.essntl.features.currency.data.di.CurrencyModule.module : org.koin.core.module.Module get() = com_essntl_features_currency_data_di_CurrencyModule
